module.exports = __webpack_public_path__ + "static/cover-0cceff87e91de833de3b972644242e26.jpg";